import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import HamburgerIcon from '@client/components/hamburgerIcon/HamburgerIcon';
import styles from './notificationProvider.scss';

export const NotificationContext = React.createContext();

class NotificationProvider extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      notificationType: '',
      notificationMessage: '',
    };
    this.componentIsMounted = false;
    this.notificationTimer = null;
  }

  componentDidMount() {
    this.componentIsMounted = true;
  }

  componentWillUnmount() {
    this.componentIsMounted = false;
    if (this.notificationTimer) {
      clearTimeout(this.notificationTimer);
    }
  }

  closeNotification = () => {
    if (this.notificationTimer) {
      clearTimeout(this.notificationTimer);
    }
    this.setState(() => {
      return {
        notificationType: '',
        notificationMessage: '',
      };
    });
  };

  displayNotification = (
    notificationType = 'DEFAULT',
    message = '',
    time = 4000
  ) => {
    if (this.notificationTimer) {
      clearTimeout(this.notificationTimer);
    }
    this.setState(() => {
      return {
        notificationType: notificationType,
        notificationMessage: message,
      };
    }, this.notificationTimeoutCallback(time));
  };

  notificationTimeoutCallback = (time) => {
    this.notificationTimer = setTimeout(() => {
      if (this.componentIsMounted) {
        this.setState(() => ({
          notificationMessage: '',
          notificationType: '',
        }));
      }
      clearTimeout(this.notificationTimer);
    }, time);
  };

  render() {
    const { notificationType, notificationMessage } = this.state;
    const notificationTypeClassName = notificationType.toLowerCase();

    return (
      <NotificationContext.Provider
        value={{
          ...this.state,
          displayNotification: this.displayNotification,
          closeNotification: this.closeNotification,
        }}
      >
        <div
          className={classNames({
            [styles.notificationProvider]: true,
            [styles[notificationTypeClassName]]: true,
            [styles.hide]: !notificationMessage,
          })}
        >
          <div className={styles.content}>{notificationMessage}</div>

          <HamburgerIcon isCrossed={true} onClick={this.closeNotification} />
        </div>
        {this.props.children}
      </NotificationContext.Provider>
    );
  }
}

NotificationProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default NotificationProvider;
